var site = site || {};
site.Payment = (function () {
    var address1 = null;
    var postalCode = null;
    let spinnerIcon = `<i class="fa fa-spinner fa-1x fa-spin payment-spinner"></i>`;
    var paymentProfile = {};
    var currentSelectedCard = null;
    let $dismissConfirmation = null;

    /**
     * This is a toggle which needs to be set whenever the cc modal is hidden
     * and the changes to it should NOT be cleared out.
     */
    let ignoreNextPaymentModalHideEvent = false;

    var clearModal = function () {
        $('#add-new-credit-card-form').find('#paymentProfileID').val('');
        $('#add-new-credit-card-form').find('#firstNameInput').val('');
        $('#add-new-credit-card-form').find('#lastNameInput').val('');
        $('#add-new-credit-card-form').find('#cvvInput').val('');
        $('#add-new-credit-card-form').find('#cardNumberInput').val('');
        $('#add-new-credit-card-form').find('#cardExpDateInput').val('');
        $('#add-new-credit-card-form').find('#streetAddressInput').val('');
        $('#add-new-credit-card-form').find('#address2').val('');
        $('#add-new-credit-card-form').find('#zipCodeInput').val('');
        $('#add-new-credit-card-form').find('#cityInput').val('');
        $('#add-new-credit-card-form').find('#stateSelectInput').val('')
        $('#add-new-credit-card-form').find('#county').val();
        $('#add-new-credit-card-form').find('#phoneNumberInput').val('');
        $('#add-new-credit-card-form').find('#autoShipExists').val('');
        $('#add-new-credit-card-form').find('#defaultCardCheck').prop('checked', false);
        $('#savePaymentProfile').text('Save')
        $('#savePaymentProfile').prop('disabled', false);

        $('#add-new-credit-card-form').find('#cardExpirError').removeClass('payment-error');
        $('#add-new-credit-card-form').find('#firstNameError').removeClass('payment-error')
        $('#add-new-credit-card-form').find('#lastNameError').removeClass('payment-error');
        $('#add-new-credit-card-form').find('#cvvError').removeClass('payment-error');
        $('#add-new-credit-card-form').find('#cardNumberError').removeClass('payment-error');
        $('#add-new-credit-card-form').find('#cardExpirError').removeClass('payment-error');
        $('#add-new-credit-card-form').find('#streetAddressError').removeClass('payment-error');
        $('#add-new-credit-card-form').find('#stateError').removeClass('payment-error');
        $('#add-new-credit-card-form').find('#zipCodeError').removeClass('payment-error');
        $('#add-new-credit-card-form').find('#cityError').removeClass('payment-error');

        $('#add-new-credit-card-form').find('#firstNameError').text('')
        $('#add-new-credit-card-form').find('#lastNameError').text('')
        $('#add-new-credit-card-form').find('#cvvError').text('')
        $('#add-new-credit-card-form').find('#cardNumberError').text('');
        $('#add-new-credit-card-form').find('#cardExpirError').text('');
        $('#add-new-credit-card-form').find('#streetAddressError').text('');
        $('#add-new-credit-card-form').find('#cityError').text('');
        $('#add-new-credit-card-form').find('#stateError').text('');
        $('#add-new-credit-card-form').find('#zipCodeError').text('');

        $('.saveError').html('');
    }

    var resetMelissaDataButtons = function () {
        $('.payment-close-melissa-data-modal').prop('disabled', false);
        $('.payment-close-melissa-data-modal').text('No, use the address I entered');
        $('.payment-use-suggested-address').prop('disabled', false);
        $('.payment-use-suggested-address').text('Yes, use this address');
    }

    var resetPaymentProfileButtons = function () {
        $('#savePaymentProfile').prop('disabled', false);
        $('.payment-spinner').hide();
        $('#savePaymentProfile').text("Save");
    }

    var closeMelissaDataReopenCCModal = function () {
        $('#editPaymentAddressMelissaDataModal').is(':visible') ? $('#editPaymentAddressMelissaDataModal').modal("hide") : '';
        $('#addNewCreditCardModal').is(':visible') ? '' : $('#addNewCreditCardModal').modal("show");
    }

    var addPaymentProfile = function (paymentProfile) {
        $.ajax({
            method: "POST",
            url: "/Customer/PaymentProfiles",
            dataType: "json",
            data: JSON.stringify(paymentProfile),
            contentType: "application/json"
        })
            .done(function (data) {
                //determine what modal is open at this point, then close it
                $('#addNewCreditCardModal').is(':visible') ? $('#closePaymentProfile').click() : '';
                $('#addNewCreditCardModal').is(':visible') ? $('#closePaymentProfile').modal() : '';

                clearModal();
            })
            .fail(function (data) {
                console.log('Failure - Adding Payment Profile ' + data);
            });
    }

    var getPaymentProfiles = function () {
        $.ajax({
            method: "GET",
            url: "/Customer/PaymentProfiles",
            dataType: "json",
            contentType: "application/json"
        })
            .done(function (data) {
                //Check if the paymentModal was open, and hide the modal after the data has all returned
                $('#addNewCreditCardModal').is(':visible') ? $('#addNewCreditCardModal').modal("hide") : '';
                //If they had a suggestedAddress return from MelissaData and chose to save, hide the modal after the data has all returned
                $('#editPaymentAddressMelissaDataModal').is(':visible') ? $('#editPaymentAddressMelissaDataModal').modal("hide") : '';
                clearModal();
                $('#paymentMethodWrapper').html('')
                $('#paymentMethodWrapper').append(data);
                $('.review-order-section').removeClass('disabled');
            })
            .fail(function (data) {
                console.log('Failure - Getting Payment Profiles ' + data);
                //We should have a retry here to get the paymentProfiles again, check with Darren though, I'm thinking a 3x retry if not succesful using a counter at the top of file to not infinite loop, for science
            });
    }

    var savePaymentForm = function (paymentProfileData) {
        paymentProfileData.OpaqueData.descriptor = paymentProfileData.OpaqueData.dataDescriptor;
        paymentProfileData.OpaqueData.value = paymentProfileData.OpaqueData.dataValue;
        $.ajax({
            method: "POST",
            url: "/customer/upsertpaymentprofile",
            data: JSON.stringify(paymentProfileData),
            dataType: "json",
            contentType: "application/json"
        })
            .done(function (data) {
                if (data && data.success) {
                    // Need to reset the modal and the paymentProfile.
                    clearModal();
                    currentSelectedCard = new site.Payment.paymentProfileObj();
                    var response = JSON.parse(data.responseText);
                    $('.confirm-edit-payment-discard').prop('disabled', false);
                    $('.confirm-edit-payment-discard').text('');
                    $('.confirm-edit-payment-discard').append("Confirm");
                    getPaymentProfiles()
                } else if (data.statusCode == "400") {
                    $('.saveError').text(data.responseText);
                    closeMelissaDataReopenCCModal();
                }
                else if (data && JSON.parse(data.responseText).error != null && JSON.parse(data.responseText).error.message != null) {
                    $('.saveError').text(JSON.parse(data.responseText).error.message);
                    closeMelissaDataReopenCCModal();
                }
                else {
                    $('.active .billing-errors').show();
                    $('.payment-validation-message').hide();
                    var errors = JSON.parse(data.responseText);
                    $('.saveError').text(errors);
                    closeMelissaDataReopenCCModal();
                }
                resetMelissaDataButtons();
                resetPaymentProfileButtons();

            }).fail(function (data) {
                closeMelissaDataReopenCCModal();

                var i;
                if (data && data.responseJSON && data.responseJSON.indexOf('the error received was: ') > 0) {
                    var errorMessage = data.responseJSON.split('the error received was: ')[1];
                    $('.saveError').text(errorMessage);
                } else if (data && data.responseJSON) {
                    var response = JSON.parse(data.responseJSON);
                    $('.saveError').text(response);
                } else {
                    $('.saveError').text('An issue occured with the saving of this payment profile. Please refresh the page and try again');
                }
                resetMelissaDataButtons();
                resetPaymentProfileButtons();
            });

    };

    var sendPaymentDataToAnet = function (paymentProfile) {
        return new Promise((resolve, reject) => {
            var cardData = {};
            cardData.fullName = paymentProfile.firstName + ' ' + paymentProfile.lastName
            cardData.cardNumber = paymentProfile.cardNumber
            cardData.month = paymentProfile.expirationMonth
            cardData.year = paymentProfile.expirationYear
            cardData.cardCode = paymentProfile.cardCode
            $.ajax({
                method: "GET",
                url: "/customer/GetPaymentConfig",
                contentType: "application/json"
            })
                .done(function (authDataResponse) {
                    
                    if (authDataResponse && authDataResponse.responseText) {
                        var authData = JSON.parse(authDataResponse.responseText);

                        var secureData = {};
                        secureData.authData = authData;
                        secureData.cardData = cardData;
                        //pass object back to response handler 
                        Accept.dispatchData(secureData, function (res) { responseHandler(res); });
                    }
                    
                    return resolve(false); //cancel the click processing until after the dispatch processing is complete.
                })
                .fail(function (data) {
                    resetMelissaDataButtons();
                    reject();
                });
        })
    };


    function responseHandler(response, success) {
        var errors = [];
        var errorCodesToWatchFor = [
            "E_WC_05",
            "E_WC_06",
            "E_WC_07",
            "E_WC_08",
            "E_WC_15",
            "E_WC_16",
            "E_WC_17",
            "E_WC_19"
        ];

        if (response.messages.resultCode === "Error") {
            var i = 0;
            var message = "";
            var genericMessageShown = false;
                while (i < response.messages.message.length) {
                    message += response.messages.message[i].text + "<br/>";
                    console.log(
                        response.messages.message[i].code + ": " +
                        response.messages.message[i].text
                    );
                    if (errorCodesToWatchFor.indexOf(response.messages.message[i].code) >= 0) {
                        errors.push(response.messages.message[i].text);
                        //Errors here
                        $('.saveError').text(response.messages.message[i].text)
                    } else if (!genericMessageShown) {
                        genericMessageShown = true;
                        $('.saveError').text('Your credit card was not approved. Please review and update your card information or contact your bank.')
                    }
                    //disable save button
                    i = i + 1;
                }

            $('#editPaymentAddressMelissaDataModal').is(':visible') ? $('#editPaymentAddressMelissaDataModal').modal("hide") : '';
            $('.payment-close-melissa-data-modal').prop('disabled', false);
            $('.payment-close-melissa-data-modal').text('No, use the address I entered');
            $('.payment-use-suggested-address').prop('disabled', false);
            $('.payment-use-suggested-address').text('Yes, use this address');

            $('#addNewCreditCardModal').is(':visible') ? '' : $('#addNewCreditCardModal').modal("show");

            $('#savePaymentProfile').prop('disabled', false);
            $('.payment-spinner').hide();
            $('#savePaymentProfile').text("Save");
            return false;
        }
        else {
            if (success) {
                success();
            }
            //Move this up ^ after debuggin yo 
            return paymentFormUpdate(response.opaqueData);
        }
    };

    var paymentFormUpdate = function (opaqueData) {
        var paymentProfileData = {}

        //Update current PaymentForm to use the added card if this is the new default
        var paymentProfileId = $('#add-new-credit-card-form').find('#paymentProfileID').val();
        if (paymentProfileId) {
            paymentProfileData.PaymentProfileID = paymentProfileId;
        }

        paymentProfileData.cardHolderName = paymentProfile.cardHolderName;
        paymentProfileData.cardHolderFirstName = paymentProfile.firstName;
        paymentProfileData.cardHolderLastName = paymentProfile.lastName;
        paymentProfileData.Address = paymentProfile.address;
        paymentProfileData.City = paymentProfile.city;
        paymentProfileData.StateProvince = paymentProfile.stateProvince;
        paymentProfileData.PostalCode = paymentProfile.postalCode;
        //This is always United States of America
        paymentProfileData.Country = $('#add-new-credit-card-form').find('#countryInput').val();
        paymentProfileData.IsPrimary = site.Utilities.stringToBool($('#add-new-credit-card-form').find('#defaultCardCheck').is(':checked'));
        if (opaqueData) {
            paymentProfileData.OpaqueData = opaqueData;
        }
        else {
            return;
        }

        savePaymentForm(paymentProfileData)
    };

    /**
     * Constructor for payment profiles. Pulls information from the
     * '#add-new-credit-card-form' element.
     * @constructor
     */
    var PaymentProfileV2 = function () {
        var paymentProfileId = $('#add-new-credit-card-form').find('#paymentProfileID').val();
        var firstName = $('#add-new-credit-card-form').find('#firstNameInput').val();
        var lastName = $('#add-new-credit-card-form').find('#lastNameInput').val();
        var cardCode = $('#add-new-credit-card-form').find('#cvvInput').val();
        var cardNumber = $('#add-new-credit-card-form').find('#cardNumberInput').val();
        var expirationDate = $('#add-new-credit-card-form').find('#cardExpDateInput').val();
        var address = $('#add-new-credit-card-form').find('#streetAddressInput').val();
        var postalCode = $('#add-new-credit-card-form').find('#zipCodeInput').val();
        var city = $('#add-new-credit-card-form').find('#cityInput').val();
        var stateProvince = $('#add-new-credit-card-form').find('#stateSelectInput').val()
        //var county = $('#add-new-credit-card-form').find('#county').val();
        var country = $('#add-new-credit-card-form').find('#countryInput').val();
        var phone = $('#add-new-credit-card-form').find('#phoneNumberInput').val();
        var autoShipExists = site.Utilities.stringToBool($('#add-new-credit-card-form').find('#autoShipExists').val());
        var isPrimary = site.Utilities.stringToBool($('#add-new-credit-card-form').find('#defaultCardCheck').val());
        var cardHolderName = firstName + ' ' + lastName;
        var month;
        var year;

        if (expirationDate.match('/') != null) {
            month = expirationDate.split('/')[0];
            year = expirationDate.split('/')[1];
        }
        //If the user used a format such as (MM-YY)
        else if (expirationDate.match('-') != null) {
            month = expirationDate.split('-')[0];
            year = expirationDate.split('-')[1];
        }

        this.paymentProfileId = paymentProfileId;
        this.cardNumber = cardNumber;
        //this.opaqueData = opaqueData;
        this.expirationDate = expirationDate;
        //this.cardType = cardType;
        this.isPrimary = isPrimary;
        this.cardHolderName = firstName + ' ' + lastName;
        this.firstName = firstName;
        this.lastName = lastName;
        this.address = address;
        this.cardCode = cardCode;
        this.city = city;
        this.country = country;
        this.stateProvince = stateProvince;
        this.postalCode = postalCode;
        this.phone = phone;
        this.autoShipExists = autoShipExists;
        this.expirationMonth = month;
        this.expirationYear = year;
    }

    var imposeMinMax = function (el) {
        //If the element has a value
        if (el.value != "") {
            //If the user enters more than the max chars
            if (parseInt(el.value.length) > parseInt(el.max)) {
                el.value = el.value.substring(0, parseInt(el.max))
            }
        }
    }

    var validateInput = function (origin, value) {
        const containsAlpha = /[A-Za-z]/;
        const containsNumbers = /[^0-9.]/;
        const containsSymbol = /[\!\@\#\$\%\^\&\*\(\)\_\-\=\+\[\]\{\}\'\"\;\:\\\|\?\.\,\<\>]/;

        //test if requirments are met
        let hasNumber = containsNumbers.test(value);
        let hasSymbol = containsSymbol.test(value);
        let hasAlpha = containsAlpha.test(value);
        let properLength = ((value.length >= 13) && (value.length <= 19));

        var ccNumberIsValid = properLength && (
            (hasNumber && !hasSymbol)
        );

        if (hasAlpha) {
            origin.val(value.replace(/\D/g, ""))
        }
        if (hasSymbol) {
            origin.val(value.replace(containsSymbol, ''));
        }

        return origin.val();
    }

    var melissaDataLookup = function (that) {
        var updateLocation = '#add-new-credit-card-form';
        var source = $(that).attr('id');

        if (source == 'streetAddressInput') {
            address1 = $(that).val();
        }
        else if (source == 'zipCodeInput') {
            postalCode = $(that).val();
        }
        else {
            return;
        }
        if ((postalCode != null && postalCode !== undefined) && (address1 != null && address1 !== undefined) && (postalCode.length > 3 && address1.length > 3)) {
            var addressVerification = {
                addressLine1: address1,
                postalCode: postalCode
            }
            $.ajax({
                method: "POST",
                url: "/customers/AddressAutoFill",
                dataType: "json",
                data: JSON.stringify(addressVerification),
                contentType: "application/json"
            })
                .done(function (data) {
                    if (data.CodedAddresses[0] != null) {
                        $(updateLocation).find('#cityInput').val(data.CodedAddresses[0].city);
                        $(updateLocation).find('#stateSelectInput').val(data.CodedAddresses[0].stateProvince);
                    }
                })
                .fail(function (data) {
                    console.log('Failure - Update Payment Address');
                    resetMelissaDataButtons();
                });
        }
    }

    var checkCCExpiration = function (element) {
        let expiry = $('#cardExpDateInput').val();
        let expiryArray = expiry.split('/');
        if (expiryArray.length !== 2) {
            return true; // invalid format
        }
        let month = expiryArray[0];
        let year = expiryArray[1];
        if (month < 1 || month > 12) {
            return true; // invalid month
        }
        if (year.length === 2) {
            year = '20' + year; // convert to 4-digit year
        }
        if (year.length !== 4) {
            expiryArray[1] = year.substring(0, 4)
            element.value = expiryArray.join("/");
            return true; // invalid year format
        }
        let currentDate = new Date();
        let expiryDate = new Date(year, month);
        if (expiryDate < currentDate) {
            return true; // card has already expired 
        }
        return false;
    }

    var bindPaymentPage = function () {
        // Initialize the user confirmation modal for credit cards.
        const $dismissConfirmationEl = $("#edit-payment-confirmation");

        if ($dismissConfirmationEl.length > 0) {
            $dismissConfirmation = new bootstrap.Modal(
                $dismissConfirmationEl[0],
                {
                    backdrop: "static",
                    keyboard: false,
                }
            );
        }

        $(document).on('click', '.edit-credit-card-link', function (paymentProfileId, e) {
            var paymentProfileId = $(this).data().paymentProfileId;
            clearModal();
            $('.title-start').text('Edit');
            $('#addNewCreditCardModal').modal('show');
            //Get the paymentProfile
            $.ajax({
                method: "GET",
                url: "/Customer/PaymentProfile",
                dataType: "json",
                data: {
                    paymentProfileID: paymentProfileId
                },
                contentType: "application/json"
            })
                .done(function (data) {
                    if (data) {
                        //Copy the values from the server into the modal for the user to edit
                        $('#add-new-credit-card-form').find('#paymentProfileID').val(data.paymentProfileId);
                        $('#add-new-credit-card-form').find('#firstNameInput').val(data.cardHolderFirstName);
                        $('#add-new-credit-card-form').find('#lastNameInput').val(data.cardHolderLastName);
                        $('#add-new-credit-card-form').find('#cvvInput').val();
                        $('#add-new-credit-card-form').find('#cardNumberInput').val(data.cardNumber);
                        $('#add-new-credit-card-form').find('#cardExpDateInput').val(data.expirationMonth + '/' + data.expirationYear);
                        $('#add-new-credit-card-form').find('#streetAddressInput').val(data.address);
                        $('#add-new-credit-card-form').find('#zipCodeInput').val(data.postalCode);
                        $('#add-new-credit-card-form').find('#cityInput').val(data.city);
                        $('#add-new-credit-card-form').find('#stateSelectInput').val(`${data.stateProvince}`);

                        //$('#add-new-credit-card-form').find('#county').val();
                        //$('#add-new-credit-card-form').find('#countryInput').val(data.country);

                        $('#add-new-credit-card-form').find('#phoneNumberInput').val();
                        site.Utilities.stringToBool($('#add-new-credit-card-form').find('#autoShipExists').val());
                        $('#add-new-credit-card-form').find('#defaultCardCheck').prop('checked', data.isPrimary);

                        paymentProfile = new site.Payment.paymentProfileObj();
                        currentSelectedCard = $.extend(true, {}, paymentProfile);
                        $('#payment-loading-indicator').addClass('d-none');
                        $('#addNewCreditCardModal').removeClass('d-none');
                    }
                })
                .fail(function (data) {
                    console.log('Failure - Getting Payment Profile');
                });
        });

        $(document).on('click', '.add-credit-card-link', function (e) {
            clearModal();
            currentSelectedCard = new site.Payment.paymentProfileObj();
            $('.title-start').text('Add New');
            $('#payment-loading-indicator').addClass('d-none');
            $('#addNewCreditCardModal').removeClass('d-none')

            if ($('.credit-card-form-check').length <= 0) {
                $('#defaultCardCheck').prop('checked', true)
                $('#defaultCardCheck').prop('disabled', true)

            }

            $('#addNewCreditCardModal').modal('show');
        });

        $(document).on('hide.bs.modal', '#addNewCreditCardModal', function (e) {
            // Check the toggle if this hide event should be ignored.
            if (ignoreNextPaymentModalHideEvent) {
                ignoreNextPaymentModalHideEvent = false;
                return;
            }

            // If there were any changes (even to a new card), ask the user for
            // confirmation first.
            //Make into the object we require to validate
            paymentProfile = new site.Payment.paymentProfileObj();

            //See if this new object is dirty
            const hasDifference = Object.keys(paymentProfile).some(k => paymentProfile[k] !== currentSelectedCard[k]);

            if (hasDifference) {
                $dismissConfirmation.show();
            }
            else {
                currentSelectedCard = null;
                clearModal();
            }
        });

        $(document).on('click', '#savePaymentProfile', function (e) {
            $('#savePaymentProfile').prop('disabled', true);
            $('#savePaymentProfile').text('');
            $('#savePaymentProfile').append(spinnerIcon);
            //Gather field data
            paymentProfile = new site.Payment.paymentProfileObj();

            var formValid = true;
            var formErrors = {
                cardExpirError: false,
                firstNameError: false,
                lastNameError: false,
                cvvError: false,
                cardNumberError: false,
                streetAddressError: false,
                cityError: false,
                countryError: false,
                stateError: false,
                zipCodeError: false,
                firstNameError: false,
            };
            var requiredFieldText = "Required";

            if (paymentProfile.expirationDate.length > 4 && checkCCExpiration(this) == false) {
                formErrors.cardExpirError = false;
                $('#add-new-credit-card-form').find('#cardExpirError').removeClass('payment-error');
            }
            else {
                formErrors.cardExpirError = true;
                $('#add-new-credit-card-form').find('#cardExpirError').addClass('payment-error');
            }
            //Validate field data - if a user does not enter the required data; we display the error message and set the property for formErrors respective to the field to true to validate the end collection
            //firstName
            if (!paymentProfile.firstName || paymentProfile.firstName.length === 0) {
                $('#add-new-credit-card-form').find('#firstNameError').text('Enter a first name');
                $('#add-new-credit-card-form').find('#firstNameInput').focus();
                $('#add-new-credit-card-form').find('#firstNameError').addClass('payment-error');
                formErrors.firstNameError = true;
            } else {
                $('#add-new-credit-card-form').find('#firstNameError').text('')
                $('#add-new-credit-card-form').find('#firstNameError').removeClass('payment-error')
                formErrors.firstNameError = false;
            }
            //Lastname
            if (!paymentProfile.lastName || paymentProfile.lastName.length === 0) {
                $('#add-new-credit-card-form').find('#lastNameError').text('Enter a last name');
                $('#add-new-credit-card-form').find('#lastNameInput').focus();
                $('#add-new-credit-card-form').find('#lastNameError').addClass('payment-error');
                formErrors.lastNameError = true;
            } else {
                $('#add-new-credit-card-form').find('#lastNameError').text('')
                $('#add-new-credit-card-form').find('#lastNameError').removeClass('payment-error')
                formErrors.lastNameError = false;
            }
            //cardCode (CVV)
            if (!paymentProfile.cardCode || (paymentProfile.cardCode.length < 3 || paymentProfile.cardCode.length > 4)) {
                $('#add-new-credit-card-form').find('#cvvError').text('Enter a valid CVV code');
                $('#add-new-credit-card-form').find('#cvvInput').focus();
                $('#add-new-credit-card-form').find('#cvvError').addClass('payment-error');
                formErrors.cvvError = true;

            } else {
                $('#add-new-credit-card-form').find('#cvvError').text('')
                $('#add-new-credit-card-form').find('#cvvError').removeClass('payment-error');
                formErrors.cvvError = false;
            }
            //cardNumber
            if (!paymentProfile.cardNumber || (paymentProfile.cardNumber.length < 13 || paymentProfile.cardNumber.length > 19)) {
                $('#add-new-credit-card-form').find('#cardNumberError').text('Enter a valid credit card number');
                $('#add-new-credit-card-form').find('#cardNumberError').addClass('payment-error');
                $('#add-new-credit-card-form').find('#cardNumberInput').focus();
                formErrors.cardNumberError = true;

            } else {
                $('#add-new-credit-card-form').find('#cardNumberError').text('');
                $('#add-new-credit-card-form').find('#cardNumberError').removeClass('payment-error');
                formErrors.cardNumberError = false;
            }
            //expirationDate 
            if (formErrors.cardExpirError) {
                $('#add-new-credit-card-form').find('#cardExpirError').text('Enter a valid expiration date');
                $('#add-new-credit-card-form').find('#cardExpirError').addClass('payment-error');
                $('#add-new-credit-card-form').find('#cardExpDateInput').focus();

            } else {
                $('#add-new-credit-card-form').find('#cardExpirError').text('');
                $('#add-new-credit-card-form').find('#cardExpirError').removeClass('payment-error');
                formErrors.cardExpirError = false;
            }
            //streetAddress (address)
            if (!paymentProfile.address || paymentProfile.address.length === 0) {
                $('#add-new-credit-card-form').find('#streetAddressError').text('Enter an address');
                $('#add-new-credit-card-form').find('#streetAddressInput').focus();
                $('#add-new-credit-card-form').find('#streetAddressError').addClass('payment-error');
                formErrors.streetAddressError = true;
            } else {
                $('#add-new-credit-card-form').find('#streetAddressError').text('');
                $('#add-new-credit-card-form').find('#streetAddressError').removeClass('payment-error');
                formErrors.streetAddressError = false;
            }
            //city
            if (!paymentProfile.city || paymentProfile.city.length === 0) {
                $('#add-new-credit-card-form').find('#cityError').text('Enter a city');
                $('#add-new-credit-card-form').find('#cityError').addClass('payment-error');
                $('#add-new-credit-card-form').find('#cityInput').focus();
                formErrors.city = true;
            } else {
                $('#add-new-credit-card-form').find('#cityError').text('');
                $('#add-new-credit-card-form').find('#cityError').removeClass('payment-error');
                formErrors.city = false;
            }
            //StateProvince
            if (!paymentProfile.stateProvince || paymentProfile.stateProvince.length === 0 || paymentProfile.stateProvince == 'Choose') {
                $('#add-new-credit-card-form').find('#stateError').text('Select a state');
                $('#add-new-credit-card-form').find('#stateError').addClass('payment-error');
                $('#add-new-credit-card-form').find('#stateSelectInput').focus();
                formErrors.stateError = true;
            } else {
                $('#add-new-credit-card-form').find('#stateError').text('');
                $('#add-new-credit-card-form').find('#stateError').removeClass('payment-error');
                formErrors.stateError = false;
            }
            //zip
            if (!paymentProfile.postalCode || (paymentProfile.postalCode.length < 5 || paymentProfile.postalCode.length > 10)) {
                $('#add-new-credit-card-form').find('#zipCodeError').text('Enter a valid zip');
                $('#add-new-credit-card-form').find('#zipCodeError').addClass('payment-error');
                $('#add-new-credit-card-form').find('#zipCodeInput').focus();
                formErrors.zipCodeError = true;
            } else {
                var postalCodeRegex = /^\d{5}(-\d{4})?$/;
                if (!postalCodeRegex.test(paymentProfile.postalCode)) {
                    $('#add-new-credit-card-form').find('#zipCodeError').text('Invalid postal code');
                    $('#add-new-credit-card-form').find('#zipCodeError').addClass('payment-error');
                    $('#add-new-credit-card-form').find('#zipCodeInput').focus();
                    formErrors.zipCodeError = true;
                } else {
                    $('#add-new-credit-card-form').find('#zipCodeError').text('');
                    $('#add-new-credit-card-form').find('#zipCodeError').removeClass('payment-error');
                    formErrors.zipCodeError = false;
                }
            }
            //If any validation is not passed, display the error for the individual field and then set 
            if (!Object.values(formErrors).every(x => x === false)) {
                $('#savePaymentProfile').prop('disabled', false);
                $('.payment-spinner').hide();
                $('#savePaymentProfile').text("Save");
                return;
            }

            //Submit to Authorize.JS
            melissaDataVerifyAdd(paymentProfile);
        });

        var melissaDataVerifyAdd = function (address) {
            address.IsPayment = true;

            $.ajax({
                method: "POST",
                url: "/customers/AddressVerify",
                dataType: "json",
                data: JSON.stringify({
                    addressLine1: address.address,
                    addressLine2: null,
                    city: address.address,
                    stateProvince: address.stateProvince,
                    postalCode: address.postalCode,
                    county: null,
                    country: address.country,
                }),
                contentType: "application/json"
            })
                .done(function (data) {
                    //Ensure our paymentProfile is available
                    paymentProfile = new site.Payment.paymentProfileObj();
                    //If the address is not valid, offer the suggestion based off the response code
                    var errorText = '';
                    resetMelissaDataButtons();
                    if (data.AddressValid == 0 && data.CodedAddresses.length > 0) {
                        for (let i = 0; i < data.CodedAddresses.length; i++) {

                            //AE - Address Error 
                            if (data.CodedAddresses[i].melissaDataResults.filter(x => x.resultCode.includes('AE'))) {

                                errorText = data.CodedAddresses[i].melissaDataResults.filter(x => x.resultCode.includes('AE'))[0].description + ' We could not find this address. Do you still want to use it?';
                                $('.js-error-message').text(errorText)
                                $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data('address', paymentProfile.address);
                                $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data('city', paymentProfile.city);
                                $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data('stateProvince', paymentProfile.stateProvince);
                                $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data('postalCode', paymentProfile.postalCode);
                                $('#editPaymentAddressMelissaDataModal .melissaDataAddress').text(paymentProfile.address);
                                $('#editPaymentAddressMelissaDataModal .melissaDataCityStateZip').text(paymentProfile.city + ', ' + paymentProfile.stateProvince + ' ' + paymentProfile.postalCode);
                                $('#editPaymentAddressMelissaDataModal .melissaDataCounty').text(paymentProfile.county);
                                ignoreNextPaymentModalHideEvent = true;
                                $('#addNewCreditCardModal').modal("hide");
                                $('#editPaymentAddressMelissaDataModal').modal('show');
                                return;
                            }
                        }
                    } else if (!data.IsUnitedStatesAddress && data.CodedAddresses.length > 0) {
                        errorText = 'The address is not located in the United States.  Standard Process only ships products within the United States.'
                        $('.js-error-message').text(errorText)
                        $('#editPaymentAddressMelissaDataModal .melissaDataAddress').text(paymentProfile.address);
                        $('#editPaymentAddressMelissaDataModal .melissaDataCityStateZip').text(paymentProfile.city + ', ' + paymentProfile.stateProvince + ' ' + paymentProfile.postalCode);
                        $('#editPaymentAddressMelissaDataModal .melissaDataCounty').text(paymentProfile.county);
                        ignoreNextPaymentModalHideEvent = true;
                        $('#addNewCreditCardModal').modal("hide");
                        $('#editPaymentAddressMelissaDataModal').modal('show');
                        //Hide save button?
                    }
                    //AC - Address Change, this address is valid but we have a suggestion returned from MelissaData
                    else if (data.AddressValid = 1 && data.CodedAddresses.length > 0 && data.CodedAddresses[0].melissaDataResults.filter(x => x.resultCode.includes('AC')).length > 0) {
                        $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data('addressId', paymentProfile.addressId);
                        $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data('address', data.CodedAddresses[0].addressLine1);
                        $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data('city', data.CodedAddresses[0].city);
                        $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data('stateProvince', data.CodedAddresses[0].stateProvince);
                        $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data('postalCode', data.CodedAddresses[0].postalCode);
                        $('#editPaymentAddressMelissaDataModal .melissaDataAddress').text(data.CodedAddresses[0].addressLine1);
                        $('#editPaymentAddressMelissaDataModal .melissaDataCityStateZip').text(data.CodedAddresses[0].city + ', ' + data.CodedAddresses[0].stateProvince + ' ' + data.CodedAddresses[0].postalCode);
                        $('#editPaymentAddressMelissaDataModal .melissaDataCounty').text(data.CodedAddresses[0].county);
                        ignoreNextPaymentModalHideEvent = true;
                        $('#editPaymentAddressMelissaDataModal').modal('show');
                        $('#addNewCreditCardModal').modal("hide");
                    }
                    else {
                            $.when(site.Payment.sendPaymentDataToAnet(paymentProfile)).then(function (data) {
                                $('.review-order-section').prop('disabled', false)
                            }).catch(function (data) {
                                $('.review-order-section').addClass('disabled');
                                $('.review-order-section').prop('disabled', true);

                            });
                    }

                })
                .fail(function (data) {
                    $('#savePaymentProfile').prop('disabled', false);
                    $('.payment-spinner').hide();
                    $('#savePaymentProfile').text("Save");
                    resetMelissaDataButtons();

                });
        }

        $('#phoneNumberInput').on('keyup', function () {
            let phone = this.value;
            phone = phone.replace(/[^\d\-]/g, ''); // remove all non-numeric and non-dash characters
            if (phone.length >= 4 && phone[3] != '-') {
                phone = phone.substring(0, 3) + '-' + phone.substring(3);
            }
            if (phone.length >= 8 && phone[7] != '-') {
                phone = phone.substring(0, 7) + '-' + phone.substring(7);
            }
            this.value = phone;
        })


        //Formatting of the phone number
        $('#add-new-credit-card-form #phoneNumberInput').on('blur', function () {
            var numberEntered = $(this).val()
            if (numberEntered.length == 10) {
                numberEntered = numberEntered.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
                $(this).val(numberEntered)
            }
        });

        $('#add-new-credit-card-form #cardNumberInput').on('keyup', function () {
            validateInput($(this), $(this).val());
        });

        $('#add-new-credit-card-form #cvvInput').on('keyup', function () {
            $(this).val(validateInput($(this), $(this).val()))
        });

        $('#add-new-credit-card-form #cardExpDateInput').on('keyup', function () {
            let expiry = this.value;
            expiry = expiry.replace(/[^\d\/]/g, ''); // remove all non-numeric and non-forward-slash characters
            if (expiry.length >= 3 && expiry[2] != '/') {
                expiry = expiry.substring(0, 2) + '/' + expiry.substring(2);
            }
            this.value = expiry;
        });

        $('#zipCodeInput').on('keyup', function () {
            let zip = this.value;
            zip = zip.replace(/[^\d\-]/g, ''); // remove all non-numeric and non-dash characters
            if (zip.length >= 6 && zip[5] != '-') {
                zip = zip.substring(0, 5) + '-' + zip.substring(5);
            }
            this.value = zip;
        })

        $('#add-new-credit-card-form #streetAddressInput, #add-new-credit-card-form #zipCodeInput').on('blur', function () {
            melissaDataLookup(this);
        })

        $('.payment-use-suggested-address').on('click', function () {

            //Update object
            paymentProfile.address = $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data().address;
            paymentProfile.city = $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data().city;
            paymentProfile.stateProvince = $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data().stateProvince;
            paymentProfile.postalCode = $('#editPaymentAddressMelissaDataModal .melissaDataAddress').data().postalCode;

            //Update UI 
            $('#add-new-credit-card-form').find('#streetAddressInput').val(paymentProfile.address);
            $('#add-new-credit-card-form').find('#cityInput').val(paymentProfile.city);
            $('#add-new-credit-card-form').find('#stateSelectInput').val(paymentProfile.stateProvince);
            $('#add-new-credit-card-form').find('#zipCodeInput').val(paymentProfile.postalCode);

            $('.payment-close-melissa-data-modal').prop('disabled', true);
            $('.payment-use-suggested-address').prop('disabled', true);
            $('.payment-use-suggested-address').text('');
            $('.payment-use-suggested-address').append(spinnerIcon)

            $.when(site.Payment.sendPaymentDataToAnet(paymentProfile)).then(function (data) {
                $('.review-order-section').prop('disabled', false)
            }).catch(function (data) {
                $('.review-order-section').addClass('disabled');
                $('.review-order-section').prop('disabled', true);

            });
            $('#editPaymentAddressMelissaDataModal').modal('hide');
            $('#addNewCreditCardModal').modal('show');
        });

        $('.payment-close-melissa-data-modal').on('click', function () {
            $('#editPaymentAddressMelissaDataModal').modal("hide");
            $('#addNewCreditCardModal').modal('show');

            $('#savePaymentProfile').prop('disabled', true);
            $('#savePaymentProfile').text('');
            $('#savePaymentProfile').append(spinnerIcon);

            $.when(site.Payment.sendPaymentDataToAnet(paymentProfile)).then(function (data) {
                $('.review-order-section').prop('disabled', false)
            }).catch(function (data) {
                $('.review-order-section').addClass('disabled');
                $('.review-order-section').prop('disabled', true);

            });

        });

        $('.cancel-edit-payment-discard').on('click', function () {
            $dismissConfirmation.hide();
            $('#addNewCreditCardModal').modal("show");

        });

        $('.confirm-edit-payment-discard').on('click', function () {
            $dismissConfirmation.hide();
            $('#addNewCreditCardModal').modal("hide");
            clearModal();
        });

        $('.payment-suggest-address-close-melissa-data-modal').on('click', function () {
            $('#savePaymentProfile').prop('disabled', false);
            $('.payment-spinner').hide();
            $('#savePaymentProfile').text("Save");
            $('#editPaymentAddressMelissaDataModal').modal("hide");
            $('#addNewCreditCardModal').modal("show");
        });
    }

    return {
        paymentProfileObj: PaymentProfileV2,
        sendPaymentDataToAnet: sendPaymentDataToAnet,
        addPaymentProfile: addPaymentProfile,
        bindPaymentPage: bindPaymentPage,
        imposeMinMax: imposeMinMax,
        validateInput: validateInput,
        melissDataLookup: melissaDataLookup
    }

}());

$(document).ready(function () {
    if ($('.checkout').is(':visible')) {
        var selected = $("input[name='paymentMethod']").filter(':checked');
        var cardExpired = false;
        if (selected.length == 0) {
            $('.review-order-section').addClass('disabled');
            $('.review-order-section').prop('disabled', true);

            return;
        }
        if (selected?.data()?.paymentTerm?.toLowerCase() == "cc") {
            cardExpired = site.Utilities.stringToBool(selected?.data()?.ccExpired?.toLowerCase())
        }
        else {
            cardExpired = false;
            $('.review-order-section').removeClass('disabled');
            $('.review-order-section').prop('disabled', false);
        }

        if (cardExpired) {
            $('.review-order-section').addClass('disabled');
            $('.review-order-section').prop('disabled', true);
            return;
        }
    }
})

